import styled, { css } from "styled-components";

export const TabLabelsWrapper = styled.div`
  display: flex;
  width: 100%;
  background: ${({ theme }) => theme.colors.default[100]};
`;

export const TabLabel = styled.button<{ $active: boolean }>`
  flex: 1;
  transition: 0.2s ease-out;
  padding: 24px 72px;
  border-radius: 12px 12px 0 0;
  font-size: 20px;
  font-weight: 550;
  line-height: 150%;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 8px;

  ${({ $active }) =>
    $active
      ? css`
          background: ${({ theme }) => theme.colors.default[50]};
          color: ${({ theme }) => theme.colors.primary.default};
        `
      : css`
          color: ${({ theme }) => theme.colors.default[400]};
        `}
  ${({ theme }) => theme.breakpoints.sm.query} {
    font-size: 14px;
    padding: 12px 24px;
  }
`;

export const TabLabelValue = styled.span`
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: clip;
`;
